// @ts-check
import { useState } from "react"
import { DateTime } from "luxon"

const useMyVacationRequestMaxDate = () => {
  const [maxDate, setMaxDate] = useState(
    DateTime.now().set({
      hour: 12,
      millisecond: 0,
      minute: 0,
      second: 0,
    })
  )

  /** @type {import('./useVacationMaxDate.hook.types')["updateMaxDate"]} */
  const updateMaxDate = (
    startDate,
    bucketDays,
    plusDays,
    accordedDays,
    additionalDays,
    disabledDayListToUse
  ) => {
    let maxDaysToUse = 0
    let index = startDate
    let disabledDate = null
    let isWeekend = false
    let isDisabled = false

    if (bucketDays) maxDaysToUse += bucketDays
    if (plusDays) maxDaysToUse += plusDays
    if (accordedDays) maxDaysToUse += accordedDays
    if (additionalDays) maxDaysToUse += additionalDays

    if (maxDaysToUse <= 1) {
      setMaxDate(index)
    } else {
      for (let i = 1; i < maxDaysToUse; i++) {
        do {
          isDisabled = false
          isWeekend = false
          index = index.plus({ days: 1 })

          isWeekend = index.weekday === 6 || index.weekday === 7
          if (disabledDayListToUse.length === 0) isDisabled = false
          else {
            isDisabled = disabledDayListToUse.some((disabledDay) => {
              disabledDate = DateTime.fromSQL(disabledDay.date?.split("T")[0])
              return disabledDate.hasSame(index, "day")
            })
          }
        } while (isWeekend || isDisabled)
      }
      setMaxDate(index)
    }
  }

  return {
    maxDate,
    setMaxDate,
    updateMaxDate,
  }
}

export default useMyVacationRequestMaxDate
